export const toSingleCell = (items: { label: string }[]) => {
  return items
    .map((u) => u.label)
    .sort((a, b) => a.localeCompare(b))
    .join(', ');
};

// Default number of values a bounded multi-value PDF cell shows before the
// remainder collapses into a "+N more" suffix.
export const MULTI_VALUE_PDF_LIMIT = 3;

// Bounds a multi-value cell for PDF export. CSV keeps the full list (via
// `exportVal`); the PDF renderer wraps text indefinitely, so an unbounded
// list (e.g. ~30 owners) grows a single row to full-page height (CUS-84).
// Joins the first `limit` labels and appends "+N more" for the rest.
export const truncateMultiValueExport = (
  labels: string[],
  limit = MULTI_VALUE_PDF_LIMIT
): string => {
  if (labels.length <= limit) {
    return labels.join(', ');
  }

  return `${labels.slice(0, limit).join(', ')} +${labels.length - limit} more`;
};
